<template>
<v-container fluid>
  <v-card>
      <v-card-title>
          <h2> Recon Files </h2>
      </v-card-title>
      <v-card-text>
          <v-row>
              <v-col cols="3">
                  <v-btn color="primary" @click="getReport">Download</v-btn>
              </v-col>
          </v-row>
      </v-card-text>
  </v-card>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
  name: 'reconfile',
  data: function () {
    return {
      loading: false,
      organisationId:''
    }
  },
  mounted () {
		this.getLoggedInUser()
	
	},
  methods: {
    getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
    getReport () {
			const url = config.serverURI + '/loan/recon/download/'+this.organisationId
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = ' reconfile.csv'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
    // downloadFile () {
    //   const url = config.serverURI + '/recon/download/'+this.organisationId
    //   this.loading = true
    //   axios({ url: url, method: 'GET', responseType: 'blob' })
    //     .then(response => {
    //       this.loading = false
    //       const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
    //       const link = document.createElement('a')
    //       link.href = url
    //       const itemFileName = 'reconfile.csv'
    //       link.setAttribute('download', itemFileName)
    //       document.body.appendChild(link)
    //       link.click()
    //     })
    //     .catch(error => {
    //       this.loading = false
    //       console.log('error', error.response)
    //     })
    // }
  }
}
</script>
<style>
</style>
